export default __webpack_public_path__ + "static/media/logo_mobile.c544185c.svg";